import clsx from "clsx";
import codeStyles from "src/components/common/Code/Code.module.scss";
import StaticCode from "src/components/common/Code/StaticCode";

export interface DocsCodeProps {
  value: string;
  language: string;
  fontSize?: number;
  softwrap?: boolean;
  className?: string;
}

/**
 * Read-only docs code with content height, as `Code` renders it with `height="auto"`, without
 * Code's editor: the docs examples (DocsLanguageTabs, InlineSdkCall) are never edited in place.
 */
const DocsCode = (props: DocsCodeProps) => {
  const { value, language, fontSize = 14, softwrap = true, className } = props;
  return (
    <div className={clsx(codeStyles.root, className)} style={{ height: "auto" }}>
      <StaticCode value={value} language={language} fontSize={fontSize} softwrap={softwrap} />
    </div>
  );
};

export default DocsCode;
